// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2025project/q1/2025economics/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getVoteList = (type: any, page: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      awards: type,
      page,
    },
  });
};
const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getRules = (type: any) => {
  const data: any = {
    1: `<p>为全面贯彻落实党的二十大和二十届二中、三中全会精神，认真学习贯彻习近平总书记视察重庆重要讲话重要指示精神、中央经济工作会议精神和市委经济工作会议精神，弘扬企业家精神、优化营商环境，重庆日报报业集团联合重庆两江新区管委会，持续开展“十大重庆经济年度人物”评选活动。</p>
  <p>在挖掘和宣传优秀企业家和创新发展案例的基础上，将活动打造一个为聚焦重庆新兴产业方向、展示创新力量、链接全球资源的高能级平台，让“重庆经济年度人物”成为重庆产业新名片，实现“发现一个人物，带动一个产业，吸引一批投资”的乘数效应，扎实推动现代化新重庆建设，为奋力谱写中国式现代化重庆篇章营造良好舆论氛围。</p>`,
      2: `<p>1.指导单位</p>
<p>重庆市委组织部、重庆市委宣传部、重庆市委统战部、重庆市委社会工作部</p>
<p>2.主办单位</p>
<p>重庆日报报业集团、重庆两江新区管委会</p>
<p>3.承办单位</p>
<p>上游新闻、两江新区党工委宣传部、两江新区统战部</p>
<p>4.组委会成员单位</p>
<p>重庆市委金融办、重庆市发展改革委、重庆市科技局、重庆市经济信息委、重庆市人力社保局、重庆市规划自然资源局、重庆市住房城乡建委、重庆市城市管理局、重庆市交通运输委、重庆市农业农村委、重庆市商务委、重庆市文化旅游委、重庆市国资委、重庆市大数据发展局、重庆市工商联</p>`,
    3: `
<p>（一）人物类</p>
<p>2024十大重庆经济年度人物</p>
<p>2024十大重庆经济年度创新人物</p>
<p>2024十大两江新区经济年度人物</p>
<p>（二）案例类</p>
<p>2024成渝地区双城经济圈协同发展创新十大案例</p>`,
    4: `<p>推动国家重大战略落地见效，主动服务融入新发展格局，扎实推动高质量发展，持续推动科技创新和产业创新融合发展，构建现代化产业体系，建设现代化新重庆作出积极贡献；全力打造“西部领先、全国进位和重庆辨识度”标志性改革成果；纵深推进成渝地区双城经济圈建设，服务推动新时代西部大开发形成新格局，深度融入全国统一大市场，激发全社会内生动力和创新活力。</p>
    <p><strong>1.人物类</strong></p>
<p>（1）基本条件</p>
<p>① 遵守国家法律，坚持正确政治方向，践行社会主义核心价值观，具有良好的职业道德和行业声誉，在爱国、创新、诚信、社会责任和国际视野等方面不断提升自己；</p>
<p>② 2024年度在同一单位担任董事长、总裁、总经理等主要领导职务，推动企业发挥更大作用实现更大发展，带领团队在核心关键技术、颠覆性创新上取得重大进展或突破；</p>
<p>③ 具有良好的社会声誉，个人及所在单位无不良会计信用、纳税信用和银行信用记录及其他违规违法行为，近三年内无重大安全、质量、环境污染事故及重大劳资领域纠纷发生；</p>
<p>④“十大重庆经济年度人物”和“十大重庆经济年度创新人物”不得同时参与。</p>
<p>（2）具体条件</p>
<p>①“十大重庆经济年度人物”所在单位是在重庆注册的法人企业并开展业务，企业注册时间为2022年1月1日前，近三年保持盈利，在创造产值、税收贡献、扩大就业、行业引领、产业升级等方面有突出表现。企业2024年营业收入5亿元以上，纳税金额3000万元以上。其中，农业、服务业企业2024年营业收入2亿元以上，纳税金额300万元以上。</p>
<p>②“十大重庆经济年度创新人物”所在单位是在重庆注册的法人企业并开展业务，企业注册时间为2024年1月1日前，在新兴产业、业态创新、数字化运营、模式创新、技术创新等方面有突出表现。2024年营业收入3000万元以上，大数据、人工智能、区块链、互联网等新兴产业的企业可适当放宽企业营业收入条件。年度研发经费投入不低于100万元，或研发经费投入强度不低于3%。农业、非高技术服务业创新企业，并且曾参与行业标准制定或具有核心技术发明专利，可适当放宽研发经费投入条件。</p>
<p>③“十大两江新区经济年度人物”所在单位是在两江新区注册的法人企业并开展业务，企业注册时间为2024年1月1日前，在加快构建现代化产业体系、发展新兴产业、提升科技创新支撑能力、提振信心加快扩大内需、着力推动区域协调发展、持续推动营商环境优化、加快推动城市品质提升等方面在两江新区及重庆有突出表现。</p>
<p>④ 参与以上三项评选，“西部领先、全国进位和重庆辨识度”标志性改革成果特别突出者，可适当放宽条件。</p>
<p><strong>2.案例类</strong></p>
<p>“成渝地区双城经济圈协同发展创新案例”在聚焦纵深推进成渝地区双城经济圈建设，协同建设现代产业体系，提质发展川渝产业合作示范园区，布局建设成渝双城低空经济走廊，打造沿江产业转移示范区，加快实施“十项行动”“四张清单”，协同推进川渝共建重点项目，强化川渝公共服务共建共享，推动政务服务“川渝通办”迭代升级，推动双核联动联建和成渝中部崛起，加快建设成渝综合性科学中心等方面涌现出的新机制、新模式、新成果，政府部门、企业、社会组织均可报名参与。</p>`,
    5: `<p>1.经济贡献力</p>
<p>2.创新变革力</p>
<p>3.行业带动力</p>
<p>4.持续发展力</p>
<p>5.社会影响力</p>`,
    6: `<p>1.广泛征集</p>
<p>2.资格审查</p>
<p>3.主题宣传</p>
<p>4.重庆新兴产业媒体探营</p>
<p>5.专家评审</p>
<p>6.组委会终审</p>
<p>7.社会公示</p>
<p>8.颁奖仪式</p>`,
  };
  return data[type];
};
// 人物
const vote = (page: number, search: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_vote/controller.php?enews=vote-list&search=${search}&page=${page}`,
  );
};
// 案例
const caseVote = (page: number, search: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_case_vote/controller.php?enews=vote-list&search=${search}&page=${page}`,
  );
};
const voteDetail = (id: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_vote/controller.php?enews=detail&id=${id}`,
  );
};
const caseDetail = (id: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_case_vote/controller.php?enews=detail&id=${id}`,
  );
};
export {
  getBaseInfo,
  getVoteList,
  getRules,
  getDetail,
  getNews,
  vote,
  caseVote,
  voteDetail,
  caseDetail,
};
